import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [userType, setUserType] = useState(""); // "student", "parent", or "teacher"
  const navigate = useNavigate();
  const [t, i18n] = useTranslation("global");

  const handleUserTypeChange = (type) => {
    setUserType(type);
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      toast.error(t("login.errors.required"));
      return;
    }

    if (!userType) {
      toast.error(t("login.errors.userTypeRequired"));
      return;
    }

    try {
      let endpoint;
      
      // Use different endpoints based on user type
      if (userType === "teacher") {
        endpoint = `${process.env.REACT_APP_API_URL}/login`;
      } else {
        // For student and parent, use the existing endpoint
        endpoint = `${process.env.REACT_APP_API_URL}/login`;
      }

      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      const result = await response.json();

      if (result && result.data) {
        // Store user data with user type
        const userDataWithType = {
          ...result.data,
          userType: userType
        };
        
        localStorage.setItem("userDataLogin", JSON.stringify(userDataWithType));

        toast.success(t("login.messages.success"), {
          autoClose: 2000,
          onClose: () => {
            navigate("/");
            localStorage.removeItem("user");
            localStorage.removeItem("otpAllowed");
          },
        });
      } else {
        toast.error(result.message || t("login.errors.failed"));
      }
    } catch (error) {
      toast.error(t("login.errors.network"));
    }
  };

  return (
    <section style={{ backgroundColor: "#193C6E", minHeight: "100vh", padding: "30px 0" }}>
      <ToastContainer />
      <div className="container h-100">
        <div className="row d-flex justify-content-center align-items-center min-vh-100">
          <div className="col-lg-6 col-md-12">
            <img src="assets/imgs/Layer 1_.png" width="100%" alt="Login Illustration" />
          </div>
          <div className="col-lg-6 col-md-12">
            <div className="card-singin  p-4">
              <img src="assets/imgs/تميز copy 1.svg" alt="Taamayaz Logo" />
              <h2 className="second-color ">{t("login.title")}</h2>
              <p className="paragraph-color">{t("login.description")}</p>

              <form onSubmit={handleLogin}>
                <label className="mb-2 d-block" htmlFor="email">{t("login.emailLabel")}</label>
                <input
                  type="email"
                  id="email"
                  className="form-control mb-2"
                  placeholder={t("login.emailPlaceholder")}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />

                <label className="mb-2 d-block" htmlFor="password">{t("login.passwordLabel")}</label>
                <div className="position-relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    className="form-control mb-2"
                    placeholder={t("login.passwordPlaceholder")}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <span
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#999",
                    }}
                    className='eye-icons'
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>

                {/* User Type Selection */}
                <label className="mb-2 d-block">{t("login.userTypeLabel")}</label>
                <div className="mb-3">
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="userType"
                      id="student"
                      value="student"
                      checked={userType === "student"}
                      onChange={() => handleUserTypeChange("student")}
                    />
                    <label className="form-check-label" htmlFor="student">
                      {t("login.student")}
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="userType"
                      id="parent"
                      value="parent"
                      checked={userType === "parent"}
                      onChange={() => handleUserTypeChange("parent")}
                    />
                    <label className="form-check-label" htmlFor="parent">
                      {t("login.parent")}
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="userType"
                      id="teacher"
                      value="teacher"
                      checked={userType === "teacher"}
                      onChange={() => handleUserTypeChange("teacher")}
                    />
                    <label className="form-check-label" htmlFor="teacher">
                      {t("login.teacher")}
                    </label>
                  </div>
                </div>

                <div className="d-flex justify-content-between align-items-center my-2">
                  <Link to="/verify-account">
                    <p style={{ color: "#352E64" }} className="text-end text-black">{t("login.verifyAccount")}</p>
                  </Link>
                  <Link to="/forget-password">
                    <p style={{ color: "#352E64" }} className="text-end">{t("login.forgotPassword")}</p>
                  </Link>
                </div>

                <button
                  type="submit"
                  style={{ backgroundColor: "#352E64", color: "white" }}
                  className="btn w-100 py-3"
                >
                  {t("login.signInButton")}
                </button>
              </form>

              <h6 style={{ color: "#352E64" }} className="mt-3 py-2">
                {t("login.noAccount")} <Link to="/register">{t("login.signUpLink")}</Link>
              </h6>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
